import * as types from './mutations-type.js';
const actions={
  [types.SET_TITLE]({commit},payload){
    commit({
      type:types.SET_TITLE,
      ...payload
    })
  },
  [types.SECOND_ID]({commit},payload){
    commit({
      type:types.SECOND_ID,
      ...payload
    })
  },
}
export default actions;


// WEBPACK FOOTER //
// ./src/store/actions.js